<template>
    <v-layout row>
        <v-flex xs12>
            <v-form v-model="valid">
                <v-card>
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs8>
                                <div class="headline">Preise</div>
                            </v-flex>
                            <v-flex xs4>
                                <v-tooltip bottom>
                                    <v-btn class="right"
                                           slot="activator"
                                           :disabled="disabled"
                                           @click="add">
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                    <span v-t="'add_price'"></span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-btn class="right"
                                           v-show="event.event_prices.length >= 2"
                                           slot="activator"
                                           :disabled="disabled"
                                           @click="remove">
                                        <v-icon>remove</v-icon>
                                    </v-btn>
                                    <span v-t="'remove_price'"></span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>

                        <v-layout row v-for="(eventPrice, index) in event.event_prices" :key="eventPrice.start">
                            <v-flex xs4>
                                <date-picker :disabled="index === 0 || disabled"
                                             v-model="eventPrice.start"
                                             label="Preisstart"
                                             :min="allowedDates(eventPrice).min"
                                             :max="allowedDates(eventPrice).max"
                                             :loading="loading"
                                             :rules="rules.priceStart"
                                             required
                                ></date-picker>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                        min="0"
                                        type="number"
                                        :label="$t('first_price')"
                                        suffix="€"
                                        v-model="eventPrice.price"
                                        :loading="loading"
                                        :disabled="disabled"
                                        :rules="rules.price"
                                        @keyup.enter="submit"
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                        min="0"
                                        type="number"
                                        :label="$t('price_reduced')"
                                        suffix="€"
                                        v-model="eventPrice.price_reduced"
                                        :loading="loading"
                                        :disabled="disabled"
                                        :rules="rules.priceReduced"
                                        @keyup.enter="submit"
                                        required
                                ></v-text-field>
                            </v-flex>
                          <v-flex xs4>
                            <v-text-field
                                min="0"
                                type="number"
                                :label="$t('max_price_per_dancer')"
                                suffix="€"
                                v-model="eventPrice.max_price_per_dancer"
                                :loading="loading"
                                :disabled="disabled"
                                :rules="rules.max_price_per_dancer"
                                @keyup.enter="submit"
                                required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
    import DatePicker from '../common/DatePicker';

    export default {
        components: {
            'date-picker': DatePicker
        },
        props: {
            value: {
                type: [Array, String]
            },
            event: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                $validates: true,
                states: [],
                valid: false,
                rules: {
                    priceStart: [
                        (v) => !!v || 'Preisstart fehlt'
                    ],
                    price: [
                        (v) => (v === 0 || !!v) || 'Erstpreis fehlt'
                    ],
                    priceReduced: [
                        (v) => (v === 0 || !!v) || 'Folgepreis fehlt'
                    ],
                    max_price_per_dancer: [
                        (v) => (v === 0 || !!v) || 'Maximale Gebühr fehlt'
                    ]
                }
            }
        },
        watch: {
            valid: function (val) {
                this.$emit('validationUpdated', val);
            }
        },
        mounted() {
            if (this.$route.params.id === undefined) {
                this.add();
            }
        },
        methods: {
            add() {
                if (this.event.event_prices.length === 0) {
                    this.event.event_prices.push({
                        start: null,
                        price: null,
                        price_reduced: null,
                        max_price_per_dancer: null,
                    });
                    return;
                }

                let lastPrice = this.event.event_prices[this.event.event_prices.length-1];

                this.event.event_prices.push({
                    start: moment(lastPrice.start).add(1, 'days').format('YYYY-MM-DD'),
                    price: null,
                    price_reduced: null,
                    max_price_per_dancer: null,
                });
            },
            remove() {
                if (this.event.event_prices.length <= 1) {
                    return;
                }

                this.event.event_prices.splice(-1,1);
            },
            allowedDates(eventPrice) {
                let index = this.event.event_prices.indexOf(eventPrice);

                let min = this.event.register_start, max = this.event.register_end;

                if (index >= 1) {
                    let lastEventPrice = this.event.event_prices[index-1];

                    min = moment(lastEventPrice.start).add(1, 'days').format('YYYY-MM-DD');
                }

                if (index < this.event.event_prices.length-1) {
                    let nextEventPrice = this.event.event_prices[index+1];

                    max = nextEventPrice.start;
                }

                return {
                    min: min,
                    max: max
                };
            }
        }
    }
</script>

<style scoped>
    .right {
        float: right;
    }
</style>
